import _ from 'lodash';
import { mapGetters } from 'vuex';

const shipping = {
  shippo: false,
  rates: [],
  from: {
    firstName: '',
    lastName: '',
    address: '',
    apt: '',
    city: '',
    state: '',
    zipCode: '',
    country: '',
  },
  to: {},
};

const payments = {
  services: {
    stripe: {
      linked: false,
    },
  },
};

const discounts = {
  storeWide: 0,
  conditions: [],
  codes: [],
};

const dynamicSetup = {
  computed: {
    ...mapGetters([
      'currentSite',
      'currentUser',
    ]),
  },
  methods: {
    noDynamicData(type) {
      const hasDynamic = this.currentSite.dynamic;
      return !hasDynamic || (hasDynamic && !this.currentSite.dynamic[type]);
    },
    dynamicSetup(type) {
      if (!this.currentSite.dynamic) {
        this.$store.dispatch('setDropletVal', {
          drp: this.currentSite,
          key: 'dynamic',
          val: {},
        });
      }
      const val = {
        items: [],
        page: {
          dynamicId: null,
          groupPageId: null,
          modal: false,
        },
        pages: [],
        groups: [],
        published: [],
        categories: [],
      };
      if (type === 'products') {
        val.currency = 'USD';
        val.taxrate = 0;
        val.logo = false;
        val.orders = [];
        val.customers = [];
        val.storeEmail = this.currentUser.email;
        val.payments = _.cloneDeep(payments);
        val.discounts = _.cloneDeep(discounts);
        val.shipping = _.cloneDeep(shipping);
      }
      this.$store.dispatch('setDropletVal', {
        drp: this.currentSite.dynamic,
        key: type,
        val,
      });
    },
    paymentSetup() {
      if (!this.currentSite.dynamic.products.payments) {
        this.$store.dispatch('setDropletVal', {
          drp: this.currentSite.dynamic.products,
          key: 'payments',
          val: _.cloneDeep(payments),
        });
      }
      if (!this.currentSite.dynamic.products.payments.services) {
        this.$store.dispatch('setDropletVal', {
          drp: this.currentSite.dynamic.products.payments,
          key: 'services',
          val: _.cloneDeep(payments.services),
        });
      }
    },
  },
};

export const SHIPPING = shipping;
export const PAYMENTS = payments;

export { dynamicSetup };



// WEBPACK FOOTER //
// ./src/mixins/dynamic-setup.js